// netResponseService.js

import workspace from "./workspace"; // same Axios instance

export const getNetResponses = async () => {
  try {
    const response = await workspace.get(`/netresponse/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching net response items:", error);
    throw error;
  }
};

export const getNetResponseById = async (id) => {
  try {
    const response = await workspace.get(`/netresponse/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching net response with ID ${id}:`, error);
    throw error;
  }
};

export const createNetResponse = async (data) => {
  try {
    const response = await workspace.post(`/netresponse/`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating net response:", error);
    throw error;
  }
};

export const updateNetResponse = async (id, data) => {
  try {
    const response = await workspace.put(`/netresponse/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating net response with ID ${id}:`, error);
    throw error;
  }
};

export const deleteNetResponse = async (id) => {
  try {
    const response = await workspace.delete(`/netresponse/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting net response with ID ${id}:`, error);
    throw error;
  }
};
